export default {
  data() {
    return { modelValidationObj: {} };
  },
  watch: {
    validation: {
      immediate: true,
      handler() {
        this.setValidationObj(this.$parent);
        if (this.modelValidationObj) {
          this.$set(this.modelValidationObj, 'anyFocus', false);
          this.$set(this.modelValidationObj, 'touched', false);
        }
      },
    },
  },
  methods: {
    setTouched() {
      if (this.validation && this.validation.$touch) {
        this.validation.$touch();
      }

      if (this.modelValidationObj && this.modelValidationObj.$touch) {
        this.modelValidationObj.$touch();
        const currentStatus = Boolean(this.modelValidationObj.anyFocus);
        this.modelValidationObj.anyFocus = !currentStatus;
      }
    },
    setAsFocus(ev, field) {
      this.setTouched();
      this.focused = field;
      this.$emit('focus', { el: this.$el, ev });
    },
    removeAsFocus(ev) {
      this.setTouched();
      this.focused = null;
      this.modelValidationObj.touched = true;
      this.$emit('blur', { el: null, ev });
    },
    setValidationObj(parent) {
      if (!parent || !parent.validation) {
        this.modelValidationObj = this.validation || {};
        return;
      }

      if (Object.keys(parent.validation).length) {
        this.modelValidationObj = parent.validation; // First level elements;
        return;
      }

      // Grouped inputs (Checkbox & Radios)
      this.modelValidationObj = parent.$parent ? parent.$parent.validation : {};
    },
  },
};
